<script type="text/javascript">
export default {
  props: {
    transaction: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      item: {},
      filters: {
        q: null,
      }
    }
  },
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.transaction.inbound', {
        transaction_uuid: this.transaction
      })+ '?q=')
        .then((response) => {
          if (response.data.data.length > 0) {
            this.item = response.data.data[0]
          }
        })
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<template>
  <log-inbound :loading="loading" :item="item" title="Request Details"/>
</template>
